export default __webpack_public_path__ + "aacfd8ce13be983cd33fb53e633fd2a2.wasm";